<template>
<Box @close="close({})">
    <template #top>Modificar Orden de Pago</template>
    <template #center>
        <div v-if="orden_pago">
            <div class="nj-cols">
                <div class="nj-panel">
                    <div class="nj-panel-content">
                        <div class="nj-subtitle-1">Orden de Pago</div>
                        <div class="nj-grid">
                            <InputText label="Descripción" v-model="orden_pago.opg_descripcion" :focus="true"></InputText>
                            <InputDate label="Fecha de pago programado" v-model="orden_pago.opg_fecha_pago_programado"></InputDate>
                            <InputSelect label="Pago de cierre" v-model="orden_pago.opg_pago_cierre" :source="pago_cierre" itemKey="id" itemValue="id" itemFilter="descripcion"
                                :labelFunction="(item) => item.descripcion">
                                <template #default="data">
                                    {{ data.item.descripcion }}
                                </template>
                            </InputSelect>
                        </div>
                        <div class="nj-grid">
                            <InputText type="number" label="Total" v-model="orden_pago.opg_total" @enter="calcular()"></InputText>
                            <InputText type="number" label="Tasa detracción" v-model="orden_pago.ori_detraccion" @enter="calcular()"></InputText>
                            <InputText type="number" label="Detracción" v-model="orden_pago.opg_detraccion" :disabled="true"></InputText>
                            <InputText type="number" label="Pago" v-model="orden_pago.opg_pago" :disabled="true"></InputText>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template #bottom>
        <Upload label="Documento" v-model="pdf"></Upload>
        <Button label="Modificar" icon="save" color="green" @click="modificar()"></Button>
    </template>
</Box>
</template>

<script>
import { mapActions } from "vuex"
import { OrdenPagoService, ResponseStatus, UsuarioService } from "../../rest"
import { Tools } from "../../util"
import Toast from "../../util/toast"
import { Box, Button, Help, InputDate, InputSelect, InputText, InputUpload, Upload } from "../components"
import OrdenCompraData from "./OrdenCompraData.vue"

export default {
    name: "ModificarOrdenPago",
    components: {
        OrdenCompraData,
        InputText,
        InputSelect,
        InputUpload,
        Button,
        Upload,
        InputDate,
        Box,
        Help,
    },
    props: {
        opg_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            orden_pago: new Object(),
            pago_cierre: [
                {
                    id: "0",
                    descripcion: "No aplicar cierre"
                },
                {
                    id: "1",
                    descripcion: "Aplicar cierre"
                }
            ],
            tasa_detraccion: 0,
            pdf: null,
        }
    },
    computed: {

    },
    methods: {
        ...mapActions("AppStore", [
            "_loadingOn",
            "_loadingOff",
        ]),
        adjuntarPdf(opg_id) {
            this._loadingOn()
            let interval = setInterval(() => {
                OrdenPagoService.adjuntarPdf(this.pdf, opg_id).then(
                    response => {
                        Toast.success(response.message)
                        this.regresar()
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
                clearInterval(interval)
                this._loadingOff()
            }, 1000)
        },
        modificar() {
            this.orden_pago.opg_creador = UsuarioService.getUsuario().usu_id
            Tools.validate([
                this.orden_pago.opg_creador,
                this.orden_pago.opg_descripcion,
                this.orden_pago.opg_fecha_pago_programado,
                this.orden_pago.opg_total,
                this.orden_pago.opg_pago_cierre,
            ], "Falta ingresar datos para modificar la orden de pago")
            OrdenPagoService
                .modificar({
                    orden_pago: this.orden_pago
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.close({
                            buscar_ordenes_pago: true,
                        })
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        close({
            interfaz = "none",
            buscar_ordenes_pago = false,
            buscar_datos_orden = false
        }) {
            this.$emit("close", {
                interfaz,
                buscar_ordenes_pago,
                buscar_datos_orden,
            })
        },
        calcular() {
            this.orden_pago.opg_detraccion = parseFloat(this.orden_pago.opg_total).toFixed(2) * this.orden_pago.ori_detraccion.toFixed(2)
            this.orden_pago.opg_pago = this.orden_pago.opg_total - this.orden_pago.opg_detraccion
        },
    },
    mounted() {
        OrdenPagoService
            .obtener({
                orden_pago: {
                    opg_id: this.opg_id
                }
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.orden_pago = response.data
                    this.orden_pago.opg_pago_cierre = this.orden_pago.opg_pago_cierre.toString() // revisar cual es la mejor manera
                }
                else {
                    Toast.warn(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    },

}
</script>
<style scoped></style>